if ($('#locknlist_payment_page').length) {
    $(function () {
        const stripe = Stripe($('#payment-form').data('public-key'));

        let elements;

        var createUrl = $('#payment-form').data('create-url');
        var successUrl = $('#payment-form').data('success-url');

        initialize();
        checkStatus();

        $('#submit-payment').on('click', handleSubmit)

        async function initialize() {
            const response = await fetch(createUrl, {
                method: "POST",
            });
            const { clientSecret, errorMessage } = await response.json();
            if (errorMessage)
                showMessage(errorMessage, true);

            const appearance = {
                theme: 'stripe',
            };
            elements = stripe.elements({ appearance, clientSecret });

            const paymentElementOptions = {
                layout: "tabs",
            };

            const paymentElement = elements.create("payment", paymentElementOptions);
            paymentElement.mount("#payment-element");
        }

        async function handleSubmit(e) {
            e.preventDefault();
            setLoading(true);

            const { error } = await stripe.confirmPayment({
                elements,
                confirmParams: {
                    return_url: successUrl,
                },
            });

            if (error.type === "card_error" || error.type === "validation_error") {
                showMessage(error.message);
            } else {
                showMessage("An unexpected error occurred.");
            }

            setLoading(false);
        }

        async function checkStatus() {
            const clientSecret = new URLSearchParams(window.location.search).get(
                "payment_intent_client_secret"
            );

            if (!clientSecret) {
                return;
            }

            const { paymentIntent } = await stripe.retrievePaymentIntent(clientSecret);

            switch (paymentIntent.status) {
                case "succeeded":
                    showMessage("Payment succeeded!", false);
                    break;
                case "processing":
                    showMessage("Your payment is processing.", false);
                    break;
                case "requires_payment_method":
                    showMessage("Your payment was not successful, please try again.", true);
                    break;
                default:
                    showMessage("Something went wrong. Please try again", true);
                    break;
            }
        }

        function showMessage(messageText, error) {
            const messageContainer = document.querySelector("#payment-message");

            if (error)
                messageContainer.classList.add("red");

            messageContainer.classList.remove("hidden");
            messageContainer.textContent = messageText;

            setTimeout(function () {
                messageContainer.classList.add("hidden");
                messageContainer.classList.remove("red");
                messageContainer.textContent = "";
            }, 4000);
        }

        function setLoading(isLoading) {
            if (isLoading) {
                document.querySelector("#submit-payment").disabled = true;
                document.querySelector("#spinner").classList.remove("hidden");
                document.querySelector("#button-text").classList.add("hidden");
            } else {
                document.querySelector("#submit-payment").disabled = false;
                document.querySelector("#spinner").classList.add("hidden");
                document.querySelector("#button-text").classList.remove("hidden");
            }
        }
    });
}
